import { model } from "core/util";
import { LocalizedName as LocalizedNameType, LocalizedNameDto } from "types";

export const LocalizedName = model.createModel<LocalizedNameDto, LocalizedNameType>((json) => ({
    name: json.Name,
    languageCode: json.LanguageCode,
}));
